import Chennai from "../../Assets/ManageLocations/Chennai.jsx";
import Hyderabad from "../../Assets/ManageLocations/Hyderabad.jsx";
import Delhi from "../../Assets/ManageLocations/Delhi.jsx";
import Mumbai from "../../Assets/ManageLocations/Mumbai.jsx";
import Bengaluru from "../../Assets/ManageLocations/Bengaluru.jsx";
import Kolkata from "../../Assets/ManageLocations/Kolkata.jsx";
import Ahmedabad from "../../Assets/ManageLocations/Ahmedabad.jsx";
import Pune from "../../Assets/ManageLocations/Pune.jsx";
import { useSelector } from "react-redux";


export default function MetroPoliticianCities({ handleCity }) {
  const {theme} = useSelector((store)=>store.dashboard)
  const cityArr = [
    {
      cityLogo: <Chennai theme={theme} />,
      cityName: "Chennai",
      latitude: "13.03931",
      longitude: "80.24735",
      cityDBName: "Chennai",
      distDBName: "Chennai",
    },
    {
      cityLogo: <Hyderabad theme={theme} />,
      cityName: "Hyderabad",
      latitude: "17.37827",
      longitude: "78.45509",
      cityDBName: "Hyderabad",
      distDBName: "Hyderabad",
    },
    {
      cityLogo: <Mumbai theme={theme} />,
      cityName: "Mumbai",
      latitude: "19.1246",
      longitude: "72.90159",
      cityDBName: "Greater Bombay",
      distDBName: "Sub Urban Mumbai",
    },
    {
      cityLogo: <Delhi theme={theme} />,
      cityName: "Delhi",
      latitude: "28.59811",
      longitude: "77.14141",
      cityDBName: "Delhi Cantonment.",
      distDBName: "New Delhi",
    },
    {
      cityLogo: <Bengaluru theme={theme} />,
      cityName: "Bengaluru",
      latitude: "12.92906",
      longitude: "77.58834",
      cityDBName: "Bangalore",
      distDBName: "Bengaluru Urban",
    },
    {
      cityLogo: <Kolkata theme={theme} />,
      cityName: "Kolkata",
      latitude: "22.54132",
      longitude: "88.34981",
      cityDBName: "Kolkata",
      distDBName: "Kolkata",
    },
    {
      cityLogo: <Ahmedabad theme={theme} />,
      cityName: "Ahmedabad",
      latitude: "23.02566",
      longitude: "72.58717",
      cityDBName: "Ahmadabad (m Corp.)",
      distDBName: "Ahmadabad",
    },
    {
      cityLogo: <Pune theme={theme} />,
      cityName: "Pune ",
      latitude: "18.51645",
      longitude: "73.83878",
      cityDBName: "Pune",
      distDBName: "Pune",
    },
  ];

  return (
    <div className="flex flex-col py-2  ">
      <p className="text-center font-semibold w-fit mx-auto px-5 rounded-md text-blackPrimaryText dark:text-darkModeBlackPrimaryText ">
        Popular Cities
      </p>
      <div className="lg:flex lg:justify-center sm:grid sm:grid-cols-4  py-2  sm:gap-1 lg:gap-2 w-[100%] flex-wrap   ">
        {cityArr?.map((city, index) => (
          <div
            tabIndex="0"
            onClick={() => handleCity(city)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault(); // Prevent default behavior (e.g., scroll on spacebar)
                handleCity(city); // Call the same function on key press
              }
            }}
            className=" lg:w-[20%]  bg-cardBgColor dark:bg-darkModeCardBgColor  py-1  rounded-md cursor-pointer   "
            key={index}
            // style={{
            //   background: "rgba(255, 255, 255, 0.1)",
            //   boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            //   backdropFilter: "blur(5.5px)",
            //   WebkitBackdropFilter: "blur(5.5px)",
            //   borderRadius: "10px",
            // }}
          >
            <div className="flex  flex-col items-center justify-center">
              <div className="w-10 h-10">{city.cityLogo}</div>

              <p className="text-xs font-semibold text-blackPrimaryText dark:text-darkModeBlackPrimaryText">
                {city.cityName}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
